(function (root) {
"use strict";
var K = root.SDRKit;
if (!K) return;
var M = root.SudaderotasMotor;
if (!M || !M.API) return;
var A = M.API, PW = A.PW;
K.A = A; K.M = M;
K.FRED = "'Fredoka','Nunito',system-ui,sans-serif";
function lienzo(w, h) { var c = document.createElement("canvas"); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
function escala(ctx) { var t = ctx.getTransform ? ctx.getTransform() : { a: 1, b: 0 }; return Math.max(.25, Math.hypot(t.a, t.b)); }
K.lienzo = lienzo; K.escala = escala;
K.capital = function (t) {
t = (t || "").trim(); if (!t) return "";
if (t !== t.toUpperCase()) return t;
return t.toLowerCase().replace(/(^|[ •·-])([a-záéíóúñü])/g, function (m, a, b) { return a + b.toUpperCase(); });
};
K.anio = function () { var d = new Date(); return d.getMonth() >= 6 ? d.getFullYear() : d.getFullYear() - 1; };
K.mosaico = function (ctx, img, x, y, w, h) {
if (!img) return; var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, k = h / ih, tw = iw * k, x0 = x + w / 2 - tw / 2;
while (x0 > x) x0 -= tw;
for (; x0 < x + w; x0 += tw) ctx.drawImage(img, x0, y, tw + .5, h);
};
K.cubrir = function (ctx, img, x, y, w, h, oy) {
if (!img) return; var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, k = Math.max(w / iw, h / ih);
ctx.drawImage(img, x + (w - iw * k) / 2, y + (h - ih * k) * (oy == null ? .5 : oy), iw * k, ih * k);
};
K.estampa = function (ctx, img, cr, cx, cy, d, borde) {
var b = A.cabeza(ctx, img, cr, cx, cy, d, !0), im = img || M.ejemploRecorte();
if (!im.recorte) { A.cabeza(ctx, img, cr, cx, cy, d); return b; }
var s = escala(ctx), r = Math.max(4, b.w * (borde == null ? .045 : borde)), pad = r * 3, W = (b.w + pad * 2) * s, H = (b.h + pad * 2) * s;
var sil = lienzo(W, H), sx = sil.getContext("2d"); sx.setTransform(s, 0, 0, s, (pad - b.x) * s, (pad - b.y) * s); sx.drawImage(im, b.x, b.y, b.w, b.h);
var pet = lienzo(W, H); pet.getContext("2d").drawImage(sil, 0, 0);
sx.setTransform(1, 0, 0, 1, 0, 0); sx.globalCompositeOperation = "source-in"; sx.fillStyle = "#fff"; sx.fillRect(0, 0, W, H);
var bo = lienzo(W, H), bx = bo.getContext("2d"); for (var a = 0; a < 24; a++) bx.drawImage(sil, Math.cos(a / 24 * 6.283) * r * s, Math.sin(a / 24 * 6.283) * r * s);
ctx.save(); ctx.shadowColor = "rgba(40,30,60,.3)"; ctx.shadowBlur = r * 1.3 * s; ctx.shadowOffsetY = r * .6 * s; ctx.drawImage(bo, b.x - pad, b.y - pad, b.w + pad * 2, b.h + pad * 2); ctx.restore();
ctx.drawImage(pet, b.x - pad, b.y - pad, b.w + pad * 2, b.h + pad * 2);
return b;
};
K.mascotas = function (ctx, estado, fotos, cy, esc, max) {
var n = Math.min(estado.cantidad, max || 3), pos = A.posiciones(n, cy, esc[n - 1] || esc[0]);
return pos.map(function (q, i) { return K.estampa(ctx, fotos[i], A.crop(estado, i), q.x, q.y, q.d); });
};
K.letras = function (ctx, txt, x, y, tam, maxw, fill, dark, opt) {
if (!txt) return; opt = opt || {}; var t = tam, peso = opt.peso || 700;
function f() { ctx.font = peso + " " + t + "px " + (opt.fuente || K.FRED); } f();
while (ctx.measureText(txt).width > maxw && t > 18) { t -= 3; f(); }
ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.lineJoin = "round";
var s = escala(ctx);
if (opt.borde !== false) { ctx.save(); ctx.shadowColor = "rgba(40,30,60,.28)"; ctx.shadowBlur = t * .12 * s; ctx.shadowOffsetY = t * .06 * s; ctx.strokeStyle = opt.borde || "#fff"; ctx.lineWidth = t * .3; ctx.strokeText(txt, x, y); ctx.restore(); }
if (dark) { ctx.strokeStyle = dark; ctx.lineWidth = t * .12; ctx.strokeText(txt, x, y); }
if (fill && fill.addColorStop === undefined && fill === "oro") { var g = ctx.createLinearGradient(0, y - t * .5, 0, y + t * .5); g.addColorStop(0, "#fff6c9"); g.addColorStop(.45, "#f9cf55"); g.addColorStop(1, "#c98a16"); ctx.fillStyle = g; }
else ctx.fillStyle = fill;
ctx.fillText(txt, x, y);
ctx.save(); ctx.beginPath(); ctx.rect(x - maxw, y - t * .6, maxw * 2, t * .42); ctx.clip(); ctx.globalAlpha = .3; ctx.fillStyle = "#fff"; ctx.fillText(txt, x, y); ctx.restore();
return t;
};
K.cinta = function (ctx, cx, cy, w, h, c1, c2) {
var x0 = cx - w / 2, x1 = cx + w / 2, cola = h * .9, sc = escala(ctx);
ctx.save(); ctx.shadowColor = "rgba(40,30,60,.25)"; ctx.shadowBlur = h * .25 * sc; ctx.shadowOffsetY = h * .1 * sc;
[-1, 1].forEach(function (l) { var xe = l < 0 ? x0 : x1; ctx.fillStyle = c2; ctx.beginPath(); ctx.moveTo(xe - l * h * .2, cy - h * .2); ctx.lineTo(xe + l * cola, cy - h * .2); ctx.lineTo(xe + l * cola * .7, cy + h * .25); ctx.lineTo(xe + l * cola, cy + h * .7); ctx.lineTo(xe - l * h * .2, cy + h * .7); ctx.closePath(); ctx.fill(); });
ctx.restore();
var g = ctx.createLinearGradient(0, cy - h / 2, 0, cy + h / 2); g.addColorStop(0, c1); g.addColorStop(1, c2); ctx.fillStyle = g;
ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x0, cy - h / 2, w, h, h * .2); else ctx.rect(x0, cy - h / 2, w, h); ctx.fill();
ctx.save(); ctx.strokeStyle = "rgba(255,255,255,.6)"; ctx.lineWidth = h * .035; ctx.setLineDash([h * .12, h * .09]);
[cy - h * .36, cy + h * .36].forEach(function (y) { ctx.beginPath(); ctx.moveTo(x0 + h * .15, y); ctx.lineTo(x1 - h * .15, y); ctx.stroke(); }); ctx.restore();
};
var ART = {}, SUAVE = {}, BUSCAR_ILLUSTRATOR = false;
function cargarImagenSvg(texto) {
return new Promise(function (ok) { var i = new Image(); i.onload = function () { ok(i); }; i.onerror = function () { ok(null); }; i.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(texto); });
}
function cargarPieza(D, pieza) {
var key = D.id + "/" + pieza, fn = D.arte[pieza];
if (!fn) return Promise.resolve();
var url = "/cdn/shop/files/sudaderotas-arte-" + D.id + "-" + pieza + ".svg";
/* ningún diseño tiene arte de Illustrator en Archivos: no lo buscamos (eran ~100 descargas fallidas en cada visita). Si subes arte, cambia BUSCAR_ILLUSTRATOR a true. */
return (BUSCAR_ILLUSTRATOR ? fetch(url, { cache: "no-cache" }).then(function (r) {
var t = r.headers.get("content-type") || "";
return r.ok && /svg|xml/.test(t) ? r.text() : null;
}).catch(function () { return null; }) : Promise.resolve(null)).then(function (texto) {
if (texto && !/^(<.xml|<svg|<!--)/.test(texto.trim())) texto = null;
D.origen = D.origen || {}; D.origen[pieza] = texto ? "illustrator" : "codigo";
return cargarImagenSvg(texto || fn());
}).then(function (img) { if (img) ART[key] = img; });
}
K.arte = function (id, pieza) { return ART[id + "/" + pieza] || null; };
K.arteSuave = function (id, pieza, px) {
var img = K.arte(id, pieza); if (!img) return null;
px = Math.min(4000, Math.max(200, Math.round(px / 100) * 100));
var key = id + pieza + px; if (SUAVE[key]) return SUAVE[key];
var w = px, h = Math.round(px * 1.25), c = lienzo(w, h), x = c.getContext("2d");
x.drawImage(img, 0, 0, w, h); x.globalCompositeOperation = "destination-in";
var gh = x.createLinearGradient(0, 0, w, 0); gh.addColorStop(0, "rgba(0,0,0,0)"); gh.addColorStop(.07, "#000"); gh.addColorStop(.93, "#000"); gh.addColorStop(1, "rgba(0,0,0,0)"); x.fillStyle = gh; x.fillRect(0, 0, w, h);
var gv = x.createLinearGradient(0, 0, 0, h); gv.addColorStop(0, "rgba(0,0,0,0)"); gv.addColorStop(.06, "#000"); gv.addColorStop(1, "#000"); x.fillStyle = gv; x.fillRect(0, 0, w, h);
if (Object.keys(SUAVE).length > 10) SUAVE = {};
return (SUAVE[key] = c);
};
var pendientes = [];
K.registrar = function (D) {
var piezas = Object.keys(D.arte);
var listo = Promise.all(piezas.map(function (p) { return cargarPieza(D, p); }));
pendientes.push(listo);
function panel(ctx, estado, fotos, H, lado) {
var k = Math.max(PW / 1000, Math.min(H / 1250, 1.04)), ox = (PW - 1000 * k) / 2, oy = (H - 1250 * k) * .6;
ctx.save(); ctx.translate(ox, oy); ctx.scale(k, k);
var img = K.arte(D.id, lado), S = K.SANGRA;
if (img && (img.naturalWidth || img.width) > 1200) ctx.drawImage(img, -S.x, -S.y, 1000 + 2 * S.x, 1250 + S.y + S.abajo);
else { var fondo = K.arteSuave(D.id, lado, 1000 * escala(ctx)); if (fondo) ctx.drawImage(fondo, 0, 0, 1000, 1250); }
if (D.dibujar && D.dibujar[lado]) D.dibujar[lado](ctx, estado, fotos, K);
ctx.restore();
}
var entrada = {
nombre: D.nombre, fondo: "nieve", max: D.max || 3, panel: panel,
fondoFn: function (ctx, estado, w, h) { D.fondo(ctx, w, h); },
pieza: function (ctx, estado, fotos, pz, sg) {
var n = pz.nombre, x = -sg - 1, y = -sg - 1, w = pz.w + 2 * sg + 2, h = pz.h + 2 * sg + 2;
if (n === "manga") { K.mosaico(ctx, K.arte(D.id, "manga"), x, y, w, h); return; }
if (n === "capucha") { K.cubrir(ctx, K.arte(D.id, "capucha"), x, y, w, h, .5); return; }
if (n === "puno" || n === "pretina" || n === "cuello_alto") {
if (h > w) { ctx.save(); ctx.translate(x + w, y); ctx.rotate(Math.PI / 2); D.resorte(ctx, 0, 0, h, w); ctx.restore(); }
else D.resorte(ctx, x, y, w, h);
}
},
arteManga: function () { return K.arte(D.id, "manga"); },
arteCapucha: function () { return K.arte(D.id, "capucha"); },
resorte: function (ctx, x, y, w, h) { D.resorte(ctx, x, y, w, h); }
};
var DIS = A.DISENOS, copia = {}, despues = D.despuesDe || "jengibre", puesto = false;
Object.keys(DIS).forEach(function (k) { copia[k] = DIS[k]; delete DIS[k]; });
Object.keys(copia).forEach(function (k) { DIS[k] = copia[k]; if (k === despues) { DIS[D.id] = entrada; puesto = true; } });
if (!puesto) DIS[D.id] = entrada;
};
var fOrig = M.fuentesListas;
M.fuentesListas = function () { return Promise.all([fOrig()].concat(pendientes)); };
})(this);